<template>
  <transition name="fade">
    <div class="popup" v-if="visible">
      <div class="popup-shadow" @click="hidePopup"></div>
      <div class="popup-main">
        <a href="javascript:;" class="popup-main-close" @click="hidePopup"></a>
        <div class="popup-main-title">
          <p class="text">{{ letter.voucherAbout }}</p>
        </div>
        <p class="popup-main-info">
          {{ letter.voucherTipSideOne }}
        </p>
        <div class="img-wrap">
          <img
            class="img"
            alt="guide-img"
            :src="item"
            v-for="item in aboutCurrenyGuideImg"
            :key="item"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'AboutCurrencyPopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang
    }),
    aboutCurrenyGuideImg() {
      return [];
    },
  },
  methods: {
    hidePopup() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';
.popup {
  z-index: 9;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-main {
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 708px;
    box-sizing: border-box;
    background: #f6f6f6;
    padding: 0 0 70px;
    border-radius: 10px;
    &-title {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 80px;
      .text {
        font-size: 30px;
        color: #333;
      }
    }
    &-info {
      font-size: 24px;
      color: #333;
      text-align: center;
      margin-bottom: 20px;
      line-height: 30px;
      padding: 0 20px;
    }
    &-close {
      position: absolute;
      right: 32px;
      top: 27px;
      background: url($commonImg + 'close.png') no-repeat;
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
  }
  .img-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 900px;
    overflow: scroll;
    .img {
      max-width: 90%;
      margin-bottom: 20px;
    }
  }

  .game-popup-bg {
    width: 100%;
    margin-bottom: 35px;
  }
}

@media screen and (orientation: landscape) {
  .popup-main {
    width: $landscapePopupWidth;
    &-title {
      height: 61px;
      line-height: 61px;

      .text {
        font-size: 22px;
      }
    }
    &-close {
      position: absolute;
      right: 15px;
      top: 19px;
      background: url($commonImg + 'close.png') no-repeat;
      width: 23px;
      height: 23px;
      cursor: pointer;
      background-size: cover;
    }
  }
  .popup .img-wrap {
    height: 210px;
    .img {
      max-width: 50%;
    }
  }
  .popup .game-popup-bg {
    margin-bottom: 18px;
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .popup .img-wrap {
    height: 400px;
  }
}

/* iPad纵向方向样式 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .popup .img-wrap {
    height: 500px;
  }
}
</style>
